import PropTypes from 'prop-types';
import {Tooltip} from 'react-tooltip';

import useUniqueId from '../../hooks/uniqId';
import InfoIcon from '../Icons/Info';

import Link from './Link';

const propTypes = {
  href: PropTypes.string.isRequired,
  /**
   * Optional tooltip text.
   */
  tooltip: PropTypes.string,
  /**
   * Forces link to be opened in new tab if true, in same tab if false.
   * If undefined, it will default to opening external links in new tab.
   */
  newTab: PropTypes.bool,
  /**
   * className for link.
   */
  className: PropTypes.string,
  /**
   * className for icon.
   */
  iconClassName: PropTypes.string,
  iconSize: PropTypes.string,
  iconTransform: PropTypes.string,
  children: PropTypes.node,
};
/**
 * Renders an information icon link with a mouseover tooltip (if `tooltip` is specified).
 */
export default function InfoLink({href, tooltip, className, iconClassName, iconSize, iconTransform, children,
  ...otherProps}) {
  const tooltipId = useUniqueId({prefix: 'tt'});

  const linkProps = {
    href,
    className,
    ...otherProps,
  };
  if (!children) {
    linkProps.iconOnly = true;
  }

  if (tooltip) {
    if (linkProps.title) {
      // tooltip trumps title
      // eslint-disable-next-line
      if (!linkProps['aria-label']) {
        linkProps['aria-label'] = linkProps.title;
      }
      delete linkProps.title;
    }
    // ReactTooltip need to be a sibling or descendent of element with data-tip,
    // otherwise we get a rendering error on Chrome.
    return (
      <Link {...linkProps} data-for={tooltipId} data-tip={tooltip}>
        <InfoIcon className={iconClassName} size={iconSize} transform={iconTransform} />{children}
        <span className="sr-only">{tooltip}</span>
        <Tooltip id={tooltipId} effect="solid" wrapper="span" />
      </Link>
    );
  } else {
    return <Link {...linkProps}><InfoIcon className={iconClassName} size={iconSize} transform={iconTransform} />{children}</Link>;
  }
}
InfoLink.propTypes = propTypes;
